import React from 'react';
import {Col, Container, Row, Card, CardBody, Button} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchAutoCustomeraDataIfNeeded} from '../../redux/actions/AutoCustomersActions';
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import MultiSelectionFilter from './components/MultiSelectionFilter';
import CustomersTable from './components/CustomersTable'
import * as TextManager from "../../modules/languages/TextManager";
import DateSelector from '../../components/DateSelector'
import axios from 'axios';
import * as environment from '../../../src/modules/environment.js';


export class AutoCustomers extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            timerLoaded: false
        };
    }

    componentDidMount() {        
        this.props.dispatch(fetchAutoCustomeraDataIfNeeded(this.queryParams));

        this.props.dispatch(fetchUtilsDataIfNeeded());
    }

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if(typeof mr === 'number' ) {
                    if(mr.toString(16).toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };


    render() {

        let dealTypes = [/*{value: 0, label: 'All'}, */{value: 1, label: 'סלולר'},
            {value: 2,label: 'טלוויזיה'},
            {value: 3, label: 'אינטרנט'}];
        let providers = [];
        let stores = [];
        let status = [
            {value: 1, label: TextManager.getCurrentTextResource().Customers.newCustomers},
            {value: 2, label: TextManager.getCurrentTextResource().Customers.activeCustomers},
            {value: 3, label: TextManager.getCurrentTextResource().Customers.inactiveCustomers},
            {value: 4, label: TextManager.getCurrentTextResource().Customers.inMaintenance},
            {value: 5, label: TextManager.getCurrentTextResource().Customers.halfDone},
            {value: 6, label: 'לקוחות מעטפה'}];

        let statusLong = [
            {value: 1, label: TextManager.getCurrentTextResource().Customers.newCustomers},
            {value: 2, label: TextManager.getCurrentTextResource().Customers.activeCustomers},
            {value: 3, label: TextManager.getCurrentTextResource().Customers.inactiveCustomers},
            {value: 4, label: TextManager.getCurrentTextResource().Customers.inMaintenance},
            {value: 5, label: TextManager.getCurrentTextResource().Customers.halfDone},
            {value: 6, label: 'לקוחות מעטפה'},
            {value: 7, label: 'לקוחות עם תזכורת'},
            {value: 8, label: 'לקוחות עם תמונה'},
            {value: 9, label: 'לקוחות בטיפול'},
            {value: 10, label: 'פעיל אוטו'},
            {value: 11, label: 'חדש מברג'},
            {value: 12, label: 'הזמנה עלתה אוטומציה'},
            {value: 13, label: 'בוצע חלקית אוטומציה'}
            ];

        let secondStatus = [
            {value: 0, label: TextManager.getCurrentTextResource().Customers.secondStatusNo},
            {value: 1, label: TextManager.getCurrentTextResource().Customers.secondStatusYes}];

        let isNewInLine = [
            {value: 1, label: 'קו חדש'},
            {value: 2, label: 'קו מנוייד'}];

        if (this.props.utilsData && this.props.utilsData.data) {
            for (let indx in this.props.utilsData.data.providers) {
                providers.push(this.props.utilsData.data.providers[indx]);
            }

            for (let indx in this.props.utilsData.data.stores) {
                stores.push(this.props.utilsData.data.stores[indx]);
            }
        }

        let userType = undefined;
        let isManager = false;
        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.userType) {

            userType = this.props.userData.data.userType;
            isManager = this.props.userData.data.isManager;
            isAdmin = this.props.userData.data.isAdmin;
        }

        let data = this.props.data;

        if (this.state.searchValue !== '') {
            data = this.props.data.filter(this.filterDataBySearch)
        }

        //const biggerThan1025 = window.matchMedia("(min-width: 1025px)").matches;
        let isWarning = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.id &&
            this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.isWarning) {
            if( environment.ListManagersFeatures.includes(this.props.userData.data.id) || isAdmin) {
                //isWarning = this.props.utilsData.data.isWarning < 3;
                isWarning = !(this.props.utilsData.data.isWarning.war1 === true && this.props.utilsData.data.isWarning.war2 === true &&
                             this.props.utilsData.data.isWarning.war3 === true)
            }
        }

        let finalStatus = status;
        let showImageDeal = true;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.id) {
            if( environment.ListManagersFeatures.includes(this.props.userData.data.id) || isAdmin) {
                finalStatus = statusLong;
            }
        }

        if(!showImageDeal && data !== undefined) {
            data = data.filter(e => e.deal_image === 0)
        }

        //console.log(data)

        return (
            <Container className='dashboard'>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={3} md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>פעולות אוטומציה</h3>
                                <div style={{display: 'flex', height: '100%', width: '85%'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>

                                      <MultiSelectionFilter items={isNewInLine} name="סוג קו"
                                                            queryParam="isNew" endpoint='auto_stat'/>
                                      <MultiSelectionFilter items={secondStatus} name="זמניים פתוחים"
                                                            queryParam="secondStatus" endpoint='auto_stat'/>
                                      <MultiSelectionFilter items={finalStatus} name="סטטוס" queryParam="status" endpoint='auto_stat'/>
                                      {(userType !== 5 && userType !== 6) && <MultiSelectionFilter items={providers}
                                                                               name={TextManager.getCurrentTextResource().Customers.provider}
                                                                               queryParam="provider" endpoint='auto_stat'/>}
                                      {(isAdmin || isManager) && <MultiSelectionFilter items={stores}
                                                                                       name={TextManager.getCurrentTextResource().Settings.store}
                                                                                       search storeGroup
                                                                                       queryParam="store" endpoint='auto_stat'/>}
                                      {(userType !== 5 && userType !== 6) &&
                                      <MultiSelectionFilter items={dealTypes} name='סוג עסקה' queryParam="dealtype" endpoint='auto_stat'/>}
                                      <DateSelector endpoint='auto_stat'/>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>

                            <CardBody style={{padding: "1.25rem"}}>
                                <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      <form className='topbar__search material-form'>
                                        <div
                                            className='search_field_form_control material-form__field topbar__search-field'>
                                            <div className='search_field_root search_field_custom-underline'
                                                 style={{border: 'groove'}}>
                                                <input className='search_field_custom-input' dir="rtl"
                                                       placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                                       value={this.state.searchValue}
                                                       onChange={(e) => this.changeSearch(e)}/>
                                            </div>
                                        </div>
                                      </form>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                    <Row>
                        <CustomersTable  key={'table'} data={data} userData={this.props.userData} refreshData={() => {
                            this.props.dispatch(fetchAutoCustomeraDataIfNeeded(this.queryParams));
                        }}/>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.autoCustomers.status,
        data: state.autoCustomers.data,
        userData: state.userData,
        utilsData: state.utilsData,
        tasksCnt: state.tasks.count,
        storeGroup: state.admin.storeGroup
    };
};

export default withRouter(connect(mapStateToProps)(AutoCustomers))